<template>
  <placeholders-form :submit-loading="submitLoading"
                     :title="$t('searchSuggestions.create.title')"
                     @submit="onSubmit">
  </placeholders-form>
</template>
<script>
  import PlaceholdersForm from './PlaceholdersForm'
  import PlaceholdersService from 'src/services/PlaceholdersService'

  export default {
    components: {
      PlaceholdersForm,
    },
    data () {
      return {
        submitLoading: false,
        suggestion: null,
      }
    },
    methods: {
      async onSubmit (data) {
        try {
          this.submitLoading = true
          await PlaceholdersService.create(data)
          this.$router.go(-1)
        } finally {
          this.submitLoading = false
        }
      },
    },
  }
</script>
<style>
</style>
